module.exports = __webpack_public_path__ + "img/logo-light.00222b23.svg";